import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import UserDashboard from "./UserDashboard";


// =========================
// Main Dashboard Pages
// =========================
import DashboardHome from "../components/user/DashboardHome";

import StudyPlans from "../components/user/StudyPlans";

import Notes from "../components/user/Notes";

import MCQs from "../components/user/MCQs";

import Mains from "../components/user/Mains";

import TestSeries from "../components/user/TestSeries";

import Profile from "../components/user/Profile";

import EditorialAnalysis from "../components/user/EditorialAnalysis";


// ✅ Monthly Magazine
import MonthlyMagazine from "../components/user/MonthlyMagazine";
import SupportCenter from "../components/user/support/SupportCenter";


// =========================
// Mains Test Series
// =========================
import MainsTestSeries from "../components/user/MainsTestSeries";

import TestsBySection from "../components/user/MainsTestSeries/TestsBySection";

import SingleMainsTestView from "../components/user/MainsTestSeries/SingleMainsTestView";




const UserDashboardRoutes = () => {

  const user = JSON.parse(
    localStorage.getItem("user")
  );

  if (!user || user.role !== "user") {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>

      <Route
        path="/"
        element={<UserDashboard />}
      >

        {/* ========================= */}
        {/* Main Dashboard Pages */}
        {/* ========================= */}

        <Route
          index
          element={<DashboardHome />}
        />

        <Route
          path="study-plans"
          element={<StudyPlans />}
        />

        <Route
          path="notes"
          element={<Notes />}
        />

        <Route
          path="mcqs"
          element={<MCQs />}
        />

        <Route
          path="mains"
          element={<Mains />}
        />

        <Route
          path="test-series"
          element={<TestSeries />}
        />

        <Route
          path="profile"
          element={<Profile />}
        />

        <Route
          path="editorial-analysis"
          element={<EditorialAnalysis />}
        />


        {/* ========================= */}
        {/* Monthly Magazine */}
        {/* ========================= */}

        <Route
          path="monthly-magazines"
          element={<MonthlyMagazine />}
        />


        {/* ========================= */}
        {/* Mains Test Series Routes */}
        {/* ========================= */}

        <Route
          path="tests/mains/view/:testId"
          element={<SingleMainsTestView />}
        />

        <Route
          path="tests/mains/:section"
          element={<TestsBySection />}
        />

        <Route
          path="tests/mains"
          element={<MainsTestSeries />}
        />

        <Route
  path="support"
  element={<SupportCenter />}
/>


        {/* ========================= */}
        {/* Fallback */}
        {/* ========================= */}

        <Route
          path="*"
          element={<Navigate to="." replace />}
        />

      </Route>
    </Routes>
  );
};

export default UserDashboardRoutes;